var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"yx-button-group pos-rela",style:(`padding-left: ${_vm.paddingLeft}px;padding-right:${_vm.paddingRight}px`)},[_vm._t("default"),_c('div',{staticClass:"split-line pos-abso",style:(`height: ${_vm.lineHeight}px`)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }